// class WishlistProduct extends HTMLElement {
//   constructor() {
//     super();
//     this.addEventListener("click", this.onAddWishlist);
//     this.LOCAL_STORAGE_WISHLIST_KEY = "shopify-wishlist";
//     this.LOCAL_STORAGE_DELIMITER = ",";
//     this.BUTTON_ACTIVE_CLASS = "active";
//     this.moveToWishlistInProgress = false;
//     this.processedCartItems = new Set(); // Track processed items
//     this.onAddActiveClass();
//     this.WishlistItemCounter();
//     this.initToastStyles();
//     this.startCartCheck();
//     this.initMoveToWishlistListener();
    
//     // Debounced grid update function
//     this.debouncedGridUpdate = this.debounce(() => {
//       const grid = document.querySelector("[grid-wishlist]");
//       if (grid) {
//         setupGrid(grid);
//       }
//     }, 500); // 500ms debounce delay
//   }

//   // Debounce utility function
//   debounce(func, delay) {
//     let timeoutId;
//     return (...args) => {
//       clearTimeout(timeoutId);
//       timeoutId = setTimeout(() => func.apply(this, args), delay);
//     };
//   }

//   // Listen for move to wishlist button clicks
//   initMoveToWishlistListener() {
//     document.addEventListener('click', (e) => {
//       if (e.target.matches('.Move-to-wishlist-cart-items') || e.target.closest('.Move-to-wishlist-cart-items')) {
//         this.moveToWishlistInProgress = true;
//         // Clear processed items when moving to wishlist
//         this.processedCartItems.clear();
//         // Stop checking cart for 3 seconds to allow move to wishlist to complete
//         setTimeout(() => {
//           this.moveToWishlistInProgress = false;
//         }, 3000);
//       }
//     });
//   }

//   // Optimized cart check with reduced frequency and better state management
//   startCartCheck() {
//     // Reduce frequency to 3 seconds for less aggressive polling
//     this.cartCheckInterval = setInterval(() => {
//       this.checkCartAndRemoveFromWishlist();
//     }, 3000);
//   }

//   // Enhanced cart check with proper state tracking
//   checkCartAndRemoveFromWishlist() {
//     // Skip if move to wishlist is in progress
//     if (this.moveToWishlistInProgress) return;
    
//     const wishlist = this.getWishlist();
//     if (wishlist.length === 0) {
//       this.processedCartItems.clear();
//       return;
//     }

//     fetch('/cart.js')
//       .then(response => response.json())
//       .then(cart => {
//         const cartProductHandles = cart.items.map(item => {
//           return item.product_handle || item.handle;
//         }).filter(handle => handle);

//         // Create a unique key for this cart state
//         const cartStateKey = cartProductHandles.sort().join(',');
        
//         // Only process if cart state has changed
//         if (this.lastCartState === cartStateKey) {
//           return;
//         }
        
//         this.lastCartState = cartStateKey;
//         let removedItems = [];

//         wishlist.forEach(handle => {
//           if (cartProductHandles.includes(handle) && !this.processedCartItems.has(handle)) {
//             // Mark as processed to prevent repeated removal
//             this.processedCartItems.add(handle);
            
//             // Remove from wishlist
//             this.updateWishlist(handle);
//             removedItems.push(handle);
            
//             // Update button states immediately
//             const wishlistButtons = document.querySelectorAll(`button[data-product-handle="${handle}"]`);
//             wishlistButtons.forEach(button => {
//               button.classList.remove(this.BUTTON_ACTIVE_CLASS);
//             });
//           }
//         });

//         // Only update UI if items were actually removed
//         if (removedItems.length > 0) {
//           // Update counter
//           this.WishlistItemCounter();
          
//           // Use debounced grid update to prevent flickering
//           this.debouncedGridUpdate();
          
//           // Clean up processed items that are no longer in cart
//           this.processedCartItems.forEach(handle => {
//             if (!cartProductHandles.includes(handle)) {
//               this.processedCartItems.delete(handle);
//             }
//           });
//         }
//       })
//       .catch(error => {
//         // Silently handle errors to avoid console spam
//       });
//   }

//   // Enhanced wishlist update to work better with state tracking
//   onAddWishlist() {
//     const wishlistItem = this.querySelector("button");
//     let productHandle = wishlistItem.dataset.productHandle || false;
//     if (!productHandle)
//       return console.error(
//         "[Wishlist] Missing `data-product-handle` attribute. Failed to update the wishlist."
//       );

//     // Check if product is currently in wishlist
//     const isInWishlist = this.wishlistContains(productHandle);
    
//     this.updateWishlist(productHandle);
//     this.WishlistItemCounter();

//     // Clear from processed items when manually toggling
//     if (isInWishlist) {
//       this.processedCartItems.delete(productHandle);
//     }

//     // Show appropriate toast message
//     if (isInWishlist) {
//       this.showToast('Removed from wishlist', 'remove');
//     } else {
//       this.showToast('Added to wishlist', 'success');
//     }

//     let grid = document.querySelector("[grid-wishlist]") || false;

//     if (grid) {
//       // On wishlist page - use debounced update instead of immediate re-render
//       this.debouncedGridUpdate();
//     } else {
//       // Not on wishlist page - toggle button state with animation
//       wishlistItem.classList.add("loading", "adding");
//       setTimeout(function () {
//         wishlistItem.classList.remove("loading");
//         wishlistItem.classList.toggle("active");
//       }, 500);

//       setTimeout(function () {
//         const addingElement = document.querySelector(".adding");
//         if (addingElement) {
//           addingElement.classList.remove("adding");
//         }
//       }, 1000);
//     }
//   }

//   // Clean up interval when element is removed
//   disconnectedCallback() {
//     if (this.cartCheckInterval) {
//       clearInterval(this.cartCheckInterval);
//     }
//   }

//   // Rest of the methods remain the same...
//   initToastStyles() {
//     if (!document.getElementById('wishlist-toast-styles')) {
//       const style = document.createElement('style');
//       style.id = 'wishlist-toast-styles';
//       style.textContent = `
//         .wishlist-toast {
//           position: fixed;
//           bottom: 20px;
//           left: 50%;
//           background: #CAC5C0;
//           color: white;
//           padding: 12px 20px;
//           border-radius: 0px;
//           font-size: 14px;
//           font-weight: 500;
//           z-index: 10000;
//           transform: translateX(400px);
//           opacity: 0;
//           transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
//           max-width: 300px;
//           display: flex;
//           align-items: center;
//           gap: 8px;
//         }
        
//         .wishlist-toast.show {
//           transform: translateX(0);
//           opacity: 1;
//         }
        
//         .wishlist-toast.success {
//           background: black;
//         }
        
//         .wishlist-toast.remove {
//           background: black;
//         }
        
//         .wishlist-toast-icon {
//           font-size: 16px;
//         }
        
//         @media (max-width: 768px) {
//           .wishlist-toast {
//             right: 10px;
//             left: 10px;
//             max-width: none;
//             transform: translateY(-100px);
//           }
          
//           .wishlist-toast.show {
//             transform: translateY(0);
//           }
//         }
//       `;
//       document.head.appendChild(style);
//     }
//   }

//   showToast(message, type = 'success') {
//     const existingToast = document.querySelector('.wishlist-toast');
//     if (existingToast) {
//       existingToast.remove();
//     }

//     const toast = document.createElement('div');
//     toast.className = `wishlist-toast ${type}`;
    
//     const icon = type === 'success' ? '' : '';
//     toast.innerHTML = `
//       <span class="wishlist-toast-icon">${icon}</span>
//       <span>${message}</span>
//     `;

//     document.body.appendChild(toast);

//     setTimeout(() => {
//       toast.classList.add('show');
//     }, 10);

//     setTimeout(() => {
//       toast.classList.remove('show');
//       setTimeout(() => {
//         if (toast.parentNode) {
//           toast.remove();
//         }
//       }, 300);
//     }, 1000);
//   }

//   WishlistItemCounter() {
//     let WISHLIST_ITEM_COUNT = document.querySelectorAll(".wishlist__count");
//     let wishlist_item_length = this.getWishlist().length;
//     if (WISHLIST_ITEM_COUNT) {
//       WISHLIST_ITEM_COUNT.forEach((singleItem) => {
//         singleItem.innerText = wishlist_item_length;
//       });
//     }
    
//     const wishlistPageCounter = document.querySelector(".wishlist-heading-existswith-wishlist-counts-number");
//     if (wishlistPageCounter) {
//       wishlistPageCounter.innerText = wishlist_item_length;
//     }
//   }

//   onAddActiveClass() {
//     const wishlistAddedButton = this.querySelector("button");
//     if (wishlistAddedButton != null) {
//       let productHandle = wishlistAddedButton.dataset.productHandle || false;
//       if (!productHandle)
//         return console.error(
//           "[Wishlist] Missing `data-product-handle` attribute. Failed to update the wishlist."
//         );
//       if (this.wishlistContains(productHandle))
//         wishlistAddedButton.classList.add(this.BUTTON_ACTIVE_CLASS);
//     }
//   }

//   getWishlist() {
//     let wishlist =
//       localStorage.getItem(this.LOCAL_STORAGE_WISHLIST_KEY) || false;
//     if (wishlist) return wishlist.split(this.LOCAL_STORAGE_DELIMITER);
//     return [];
//   }

//   setWishlist(array) {
//     let wishlist = array.join(this.LOCAL_STORAGE_DELIMITER);
//     if (array.length)
//       localStorage.setItem(this.LOCAL_STORAGE_WISHLIST_KEY, wishlist);
//     else localStorage.removeItem(this.LOCAL_STORAGE_WISHLIST_KEY);
//     return wishlist;
//   }

//   updateWishlist(handle) {
//     let wishlist = this.getWishlist();
//     let indexInWishlist = wishlist.indexOf(handle);
//     if (indexInWishlist === -1) wishlist.push(handle);
//     else wishlist.splice(indexInWishlist, 1);
//     return this.setWishlist(wishlist);
//   }

//   wishlistContains(handle) {
//     let wishlist = this.getWishlist();
//     return wishlist.indexOf(handle) !== -1;
//   }
// }

// customElements.define("wishlist-item", WishlistProduct);

// let newWishlistObj = new WishlistProduct();

// document.addEventListener("DOMContentLoaded", function () {
//   let grid = document.querySelector("[grid-wishlist]") || false;
//   if (grid) {
//     setupGrid(grid);
//   }
// });

// // Enhanced setupGrid function with better state management
// var setupGrid = function (grid) {
//   var wishlist = newWishlistObj.getWishlist();
//   var wishlistExistBtn = document.querySelector(".wishlist-page");

//   const emptyList = document.querySelector(".wishlist-grid--empty-list");
//   const wishlistHeading = document.querySelector(".wishlist-heading-existswith-wishlist-counts");

//   if (wishlist.length > 0) {
//     wishlistExistBtn.classList.add("wishlist_exists");
    
//     grid.style.display = "flex";
    
//     if (emptyList) {
//       emptyList.style.display = "none";
//     }
//     if (wishlistHeading) {
//       wishlistHeading.style.display = "block";
//     }

//     // Add loading state to prevent flickering during fetch
//     grid.style.opacity = "0.7";

//     var requests = wishlist.map(function (handle) {
//       var productTileTemplateUrl = "/products/" + handle + "?view=wishlist";
//       return fetch(productTileTemplateUrl).then(function (res) {
//         if (res.status == 200) {
//           return res.text();
//         }
//       });
//     });

//     Promise.all(requests).then(function (responses) {
//       var wishlistProductCards = responses.join("");
//       grid.innerHTML = wishlistProductCards;
      
//       // Restore opacity after content is loaded
//       grid.style.opacity = "1";
      
//       var buttons = grid.querySelectorAll("wishlist-item") || [];
      
//       newWishlistObj.WishlistItemCounter();
//     });
    
//   } else {
//     if (wishlistExistBtn) {
//       wishlistExistBtn.classList.remove("wishlist_exists");
//     }
    
//     grid.style.display = "none";
    
//     if (emptyList) {
//       emptyList.style.display = "flex";
//     }

//     grid.innerHTML = "";
//     newWishlistObj.WishlistItemCounter();
//   }
// };






class WishlistProduct extends HTMLElement {
  constructor() {
    super();
    this.addEventListener("click", this.onAddWishlist);
    this.LOCAL_STORAGE_WISHLIST_KEY = "shopify-wishlist";
    this.LOCAL_STORAGE_DELIMITER = ",";
    this.BUTTON_ACTIVE_CLASS = "active";
    this.moveToWishlistInProgress = false;
    this.cartFetchInProgress = false;
    this.processedCartItems = new Set();
    this.pendingWishlistUpdates = new Map();



    this.onAddActiveClass();
    this.WishlistItemCounter();
    this.initToastStyles();
    this.startCartCheck();
    this.initMoveToWishlistListener();
    this.validateWishlist?.();





    // Debounced grid update
    this.debouncedGridUpdate = this.debounce(() => {
      const grid = document.querySelector("[grid-wishlist]");
      if (grid) {
        setupGrid(grid);
      }
    }, 500);

    // Debounced UI update for wishlist items
    this.debouncedWishlistUIUpdate = this.debounce(() => {
      if (!this.pendingWishlistUpdates || this.pendingWishlistUpdates.size === 0) return;

      requestAnimationFrame(() => {
        this.pendingWishlistUpdates.forEach((isActive, handle) => {
          const buttons = document.querySelectorAll(`button[data-product-handle="${handle}"]`);
          buttons.forEach(button => {
            button.classList.toggle(this.BUTTON_ACTIVE_CLASS, isActive);
          });
        });

        this.WishlistItemCounter();
        this.debouncedGridUpdate();
        this.pendingWishlistUpdates.clear();
      });
    }, 400);
  }

  // Debounce utility
  debounce(func, delay) {
    let timeoutId;
    return (...args) => {
      clearTimeout(timeoutId);
      timeoutId = setTimeout(() => func.apply(this, args), delay);
    };
  }


      validateWishlist(){
window.HS_SLIDE_CART_UPDATED = function(cart) {
//  window.location.reload(true)
 console.log("ReLOAD", JSON.stringify(cart));
 
}
    }
  // Detect move-to-wishlist clicks
  initMoveToWishlistListener() {
    document.addEventListener("click", (e) => {
      if (e.target.matches(".Move-to-wishlist-cart-items") || e.target.closest(".Move-to-wishlist-cart-items")) {
        this.moveToWishlistInProgress = true;
        this.processedCartItems.clear();
        setTimeout(() => {
          this.moveToWishlistInProgress = false;
        }, 3000);
      }
    });
  }

  // Start cart check (polling)
  startCartCheck() {
    if (this.cartCheckInterval) clearInterval(this.cartCheckInterval);
    this.cartCheckInterval = setInterval(() => {
      this.checkCartAndRemoveFromWishlist();
    }, 3000);
  }


  // Main logic: Check cart & remove items from wishlist if added to cart
 checkCartAndRemoveFromWishlist() {
  if (this.moveToWishlistInProgress || this.cartFetchInProgress) return;

  const wishlist = this.getWishlist();
  if (wishlist.length === 0) {
    this.processedCartItems.clear();
    return;
  }

  this.cartFetchInProgress = true;

  fetch("/cart.js")
    .then(res => res.json())
    .then(cart => {
      const cartProductHandles = cart.items
        .map(item => item.product_handle || item.handle)
        .filter(Boolean);

      // Always cleanup processedCartItems for items no longer in cart
      for (const handle of Array.from(this.processedCartItems)) {
        if (!cartProductHandles.includes(handle)) {
          this.processedCartItems.delete(handle);
        }
      }

      // Process wishlist items
      const removedItems = [];
      wishlist.forEach(handle => {
        if (cartProductHandles.includes(handle) && !this.processedCartItems.has(handle)) {
          this.processedCartItems.add(handle);
          this.updateWishlist(handle); 
          removedItems.push(handle);
          this.queueUIWishlistUpdate(handle, false);
        }
      });

      if (removedItems.length > 0) {
        this.debouncedWishlistUIUpdate();
      }

      // Update last cart state
      this.lastCartState = cartProductHandles.sort().join(",");
    })
    .catch(err => console.error(err))
    .finally(() => {
      this.cartFetchInProgress = false;
    });
}


  // Queue UI updates for batch processing
  queueUIWishlistUpdate(handle, isActive) {
    this.pendingWishlistUpdates.set(handle, isActive);
  }

  // Add/remove item from wishlist (button click)
  onAddWishlist() {
    const wishlistItem = this.querySelector("button");
    const productHandle = wishlistItem?.dataset?.productHandle;
    if (!productHandle)
      return console.error("[Wishlist] Missing `data-product-handle` attribute.");

    const isInWishlist = this.wishlistContains(productHandle);
    this.updateWishlist(productHandle);
    this.WishlistItemCounter();

    if (isInWishlist) {
      this.processedCartItems.delete(productHandle);
      this.showToast("Removed from wishlist", "remove");
    } else {
      this.showToast("Added to wishlist", "success");
    }

    const grid = document.querySelector("[grid-wishlist]");
    if (grid) {
      this.debouncedGridUpdate();
    } else {
      wishlistItem.classList.add("loading", "adding");
      setTimeout(() => {
        wishlistItem.classList.remove("loading");
        wishlistItem.classList.toggle("active");
      }, 500);
      setTimeout(() => {
        const addingElement = document.querySelector(".adding");
        addingElement?.classList.remove("adding");
      }, 1000);
    }
  }

  // Cleanup on element removal
  disconnectedCallback() {
    if (this.cartCheckInterval) clearInterval(this.cartCheckInterval);
  }

  // Toast styling
  initToastStyles() {
    if (!document.getElementById("wishlist-toast-styles")) {
      const style = document.createElement("style");
      style.id = "wishlist-toast-styles";
      style.textContent = `
        .wishlist-toast {
          position: fixed;
          bottom: 20px;
          left: 50%;
          background: #CAC5C0;
          color: white;
          padding: 12px 20px;
          border-radius: 0px;
          font-size: 14px;
          font-weight: 500;
          z-index: 10000;
          transform: translateX(400px);
          opacity: 0;
          transition: all 0.3s ease;
          max-width: 300px;
          display: flex;
          align-items: center;
          gap: 8px;
        }
        .wishlist-toast.show { transform: translateX(0); opacity: 1; }
        .wishlist-toast.success, .wishlist-toast.remove { background: black; }
      `;
      document.head.appendChild(style);
    }
  }

  showToast(message, type = "success") {
    const existingToast = document.querySelector(".wishlist-toast");
    existingToast?.remove();

    const toast = document.createElement("div");
    toast.className = `wishlist-toast ${type}`;
    toast.innerHTML = `<span>${message}</span>`;
    document.body.appendChild(toast);

    setTimeout(() => toast.classList.add("show"), 10);
    setTimeout(() => {
      toast.classList.remove("show");
      setTimeout(() => toast.remove(), 300);
    }, 1000);
  }

  // Wishlist counter
  WishlistItemCounter() {
    const count = this.getWishlist().length;
    document.querySelectorAll(".wishlist__count").forEach(el => (el.innerText = count));
    const pageCounter = document.querySelector(".wishlist-heading-existswith-wishlist-counts-number");
    if (pageCounter) pageCounter.innerText = count;
  }

  onAddActiveClass() {
    const btn = this.querySelector("button");
    if (!btn) return;
    const handle = btn.dataset.productHandle;
    if (!handle)
      return console.error("[Wishlist] Missing `data-product-handle` attribute.");
    if (this.wishlistContains(handle)) btn.classList.add(this.BUTTON_ACTIVE_CLASS);
  }

  // Wishlist localStorage utilities
  getWishlist() {
    const data = localStorage.getItem(this.LOCAL_STORAGE_WISHLIST_KEY);
    return data ? data.split(this.LOCAL_STORAGE_DELIMITER) : [];
  }

  setWishlist(array) {
    const wishlist = array.join(this.LOCAL_STORAGE_DELIMITER);
    if (array.length)
      localStorage.setItem(this.LOCAL_STORAGE_WISHLIST_KEY, wishlist);
    else localStorage.removeItem(this.LOCAL_STORAGE_WISHLIST_KEY);
    return wishlist;
  }

  updateWishlist(handle) {
    const wishlist = this.getWishlist();
    const index = wishlist.indexOf(handle);
    if (index === -1) wishlist.push(handle);
    else wishlist.splice(index, 1);
    return this.setWishlist(wishlist);
  }

  wishlistContains(handle) {
    return this.getWishlist().includes(handle);
  }
}

// Register element
customElements.define("wishlist-item", WishlistProduct);

// Global instance
const newWishlistObj = new WishlistProduct();

// Setup grid
document.addEventListener("DOMContentLoaded", function () {
  const grid = document.querySelector("[grid-wishlist]");
  if (grid) setupGrid(grid);
});

// Wishlist grid rendering
var setupGrid = function (grid) {
  const wishlist = newWishlistObj.getWishlist();
  const wishlistExistBtn = document.querySelector(".wishlist-page");
  const emptyList = document.querySelector(".wishlist-grid--empty-list");
  const wishlistHeading = document.querySelector(".wishlist-heading-existswith-wishlist-counts");

  if (wishlist.length > 0) {
    wishlistExistBtn?.classList.add("wishlist_exists");
    grid.style.display = "flex";
    emptyList && (emptyList.style.display = "none");
    wishlistHeading && (wishlistHeading.style.display = "block");
    grid.style.opacity = "0.7";

    Promise.all(
      wishlist.map(handle =>
        fetch(`/products/${handle}?view=wishlist`).then(res => (res.ok ? res.text() : ""))
      )
    ).then(responses => {
      grid.innerHTML = responses.join("");
      grid.style.opacity = "1";
      newWishlistObj.WishlistItemCounter();
    });
  } else {
    wishlistExistBtn?.classList.remove("wishlist_exists");
    grid.style.display = "none";
    emptyList && (emptyList.style.display = "flex");
    grid.innerHTML = "";
    newWishlistObj.WishlistItemCounter();
  }
};
